<template>
  <div
    :class="{
      rounded: true,
      'bg-white': true,
      'px-sm': true,
      'py-lg': true,
    }"
    data-testid="intern-kommentar-container"
  >
    <div class="type-body-sm flex justify-end space-x-xs" v-if="showVerified">
      <span
        class="relative -top-xs rounded-2xl bg-avtalat-teal px-sm text-white"
        v-if="internKommentar.verified || internKommentar.manuallyVerified"
        id="identifierad-status"
      >
        {{ verifiedText }}
      </span>
      <span
        class="relative -top-xs rounded-2xl bg-amber-500 px-sm text-neutral-700"
        v-else
        id="inte-identifierad-status"
      >
        {{ verifiedText }}
      </span>
    </div>
    <div class="mb-xs flex flex-row items-center justify-between">
      <div class="flex flex-row items-center gap-xs">
        <FontAwesomeIcon icon="fa-regular fa-user-headset" size="xl" />
        <span>{{
          internKommentar.updatedBy ?? internKommentar.createdBy
        }}</span>
      </div>
      <div class="space-x-sm justify-self-end">
        <span class="cursor-pointer" v-if="canEdit" @click="props.onEdit" id="intern-kommentar-redigera-button">
          <avtalat-icon
            class="align-sub text-avtalat-teal"
            id="penna_enkel"
            :size="20"
          />
          Redigera
        </span>
        <span id="intern-kommentar-datum">
          {{ formatStandardDate(internKommentar.createdAt) }}
        </span>
      </div>
    </div>
    <RichText :text="internKommentar.body" data-testid="intern-kommentar-body" />
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPaperclip,
  faUser,
  faUserHeadset,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";

import { formatStandardDate } from "@/common/formatters";
import RichText from "@/components/ui/RichText.vue";
import type { IInternKommentar } from "@/composables/KundserviceAppApiClient";

type InternKommentarBubbleProps = {
  internKommentar: IInternKommentar;
  showVerified?: boolean;
  onEdit?: () => void;
  canEdit: boolean;
};

const props = defineProps<InternKommentarBubbleProps>();

library.add(faPaperclip, faUser, faUserHeadset);

const verifiedText = computed(() => {
  const manuallyVerifiedText = props.internKommentar?.manuallyVerified
    ? "Manuellt identifierad"
    : "Inte identifierad";

  return props.internKommentar?.verified
    ? "Identifierad"
    : manuallyVerifiedText;
});
</script>
